/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Trial_ContinueInputs */

const en_dialogue_list_export_trial_continue = /** @type {(inputs: Dialogue_List_Export_Trial_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue Trial`)
};

const fr_dialogue_list_export_trial_continue = /** @type {(inputs: Dialogue_List_Export_Trial_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer l'essai`)
};

const de_dialogue_list_export_trial_continue = /** @type {(inputs: Dialogue_List_Export_Trial_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortsetzung des Verfahrens`)
};

const it_dialogue_list_export_trial_continue = /** @type {(inputs: Dialogue_List_Export_Trial_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua la prova`)
};

const ru_dialogue_list_export_trial_continue = /** @type {(inputs: Dialogue_List_Export_Trial_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжить судебное разбирательство`)
};

const es_dialogue_list_export_trial_continue = /** @type {(inputs: Dialogue_List_Export_Trial_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar la prueba`)
};

const zh_cn2_dialogue_list_export_trial_continue = /** @type {(inputs: Dialogue_List_Export_Trial_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续审判`)
};

const ja_dialogue_list_export_trial_continue = /** @type {(inputs: Dialogue_List_Export_Trial_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トライアルを続ける`)
};

const hi_dialogue_list_export_trial_continue = /** @type {(inputs: Dialogue_List_Export_Trial_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सतत् परीक्षण`)
};

const pt_pt2_dialogue_list_export_trial_continue = /** @type {(inputs: Dialogue_List_Export_Trial_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar o julgamento`)
};

/**
* | output |
* | --- |
* | "Continue Trial" |
*
* @param {Dialogue_List_Export_Trial_ContinueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_trial_continue = /** @type {((inputs?: Dialogue_List_Export_Trial_ContinueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Trial_ContinueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_trial_continue(inputs)
	if (locale === "de") return de_dialogue_list_export_trial_continue(inputs)
	if (locale === "it") return it_dialogue_list_export_trial_continue(inputs)
	if (locale === "ru") return ru_dialogue_list_export_trial_continue(inputs)
	if (locale === "es") return es_dialogue_list_export_trial_continue(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_trial_continue(inputs)
	if (locale === "ja") return ja_dialogue_list_export_trial_continue(inputs)
	if (locale === "hi") return hi_dialogue_list_export_trial_continue(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_trial_continue(inputs)
	return en_dialogue_list_export_trial_continue(inputs)
});